import * as React from 'react';

function SvgGetIntro(props) {
  return (
    <svg
      width={22}
      height={22}
      fill="none"
      viewBox="0 0 22 22"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11 1.833a4.358 4.358 0 00-4.354 4.354c0 2.356 1.842 4.263 4.244 4.346a.737.737 0 01.202 0h.064a4.343 4.343 0 004.198-4.346A4.358 4.358 0 0011 1.833zM15.657 12.97c-2.558-1.704-6.729-1.704-9.305 0-1.164.78-1.805 1.834-1.805 2.962 0 1.127.641 2.172 1.796 2.942 1.284.862 2.97 1.293 4.657 1.293 1.687 0 3.373-.431 4.657-1.293 1.155-.779 1.796-1.824 1.796-2.96-.009-1.128-.641-2.173-1.796-2.943zm-2.824 3.65h-1.146v1.145a.693.693 0 01-.687.688.692.692 0 01-.688-.688v-1.146H9.168a.693.693 0 01-.688-.687c0-.376.312-.688.688-.688h1.146v-1.146c0-.376.311-.687.687-.687.376 0 .688.312.688.687v1.146h1.145c.376 0 .688.312.688.688a.693.693 0 01-.688.687z"
        fill="#4810E9"
      />
    </svg>
  );
}

export default SvgGetIntro;
